import { request } from "../../api/api";

// Admin login
export const login = (data) => {
    return request.post('/admin-login/', data);
};
export const setPassword = (data,token) => {
    return request.post(`/set-password/${token}/`, data)
}
export const getAdminSettingsFlag = () => {
    return request.get("/get-admin-settings-flag/")
}
